module.exports = __webpack_public_path__ + "img/aires_background_hero.a96eafb1.png";